export default class EventDispatcher {
  constructor() {
    let events = {};
    this.addEventListener = (name, callback) => {
      // Check if the callback is not a function.
      if (typeof callback !== 'function') {
        console.error('The listener callback must be a function, the given type is ' + typeof callback);
        return false;
      }
      // Check if the event is not a string.
      if (typeof name !== 'string') {
        console.error('The event name must be a string, the given type is ' + typeof name);
        return false;
      }

      // Create the event if not exists.
      if (events[name] === undefined) {
        events[name] = {
          listeners: []
        };
      }
      events[name].listeners.push(callback);
    };
    this.removeEventListener = (name, callback) => {
      // Check if the event is not a string.
      if (typeof name !== 'string') {
        console.error('The event name must be a string, the given type is ' + typeof name);
        return false;
      }

      // Check if this event not exists.
      if (events[name] === undefined || events[name] === null) {
        return false;
      }
      events[name].listeners = events[name].listeners.filter(listener => {
        return listener.toString() !== callback.toString();
      });
    };
    this.removeEventListeners = (name = null) => {
      if (!name) {
        events = {};
      }

      // Check if the event is not a string.
      if (typeof name !== 'string') {
        console.error('The event name must be a string, the given type is ' + typeof name);
        return false;
      }
      events[name] = undefined;
    };
    this.dispatchEvent = (name, _details) => {
      // Check if the event is not a string.
      if (typeof name !== 'string') {
        console.error('The event name must be a string, the given type is ' + typeof name);
        return false;
      }

      // Check if this event not exists.
      if (events[name] === undefined || events[name] === null) {
        return false;
      }
      events[name].listeners.forEach(listener => {
        listener(_details);
      });
    };
  }
}